/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import dynamic from "next/dynamic";
import animationData from "./unreal-dark-cosmos.json";

const Lottie = dynamic(() => import("lottie-react"));

export const LottieLoading = (): React.JSX.Element | null => {
	return <Lottie animationData={animationData} />;
};
